import { diffWords } from "diff";

/**
 * Rapor bölümünün HTML'ini karşılaştırılabilir düz metne çevirir: paragraf ve satır sonları korunur,
 * &nbsp; ve fazla boşluklar tekilleşir. DOMParser betik çalıştırmaz; içerik yalnız metin olarak okunur.
 */
export function htmlToText(html)
{
    if (!html)
        return '';

    const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
    doc.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
    doc.querySelectorAll('p, div, li, tr, h1, h2, h3, h4, h5, h6').forEach(el => el.append('\n'));

    return (doc.body.textContent || '')
        .replace(/ /g, ' ')
        .replace(/[ \t]+/g, ' ')
        .replace(/ *\n */g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
}

/**
 * İki bölüm içeriğinin farkı.
 *   status: 'same'   → metin ve biçim aynı
 *           'format' → metin aynı, yalnız HTML (kalın, boyut vb.) değişmiş
 *           'changed'→ kelime düzeyinde fark var; parts diffWords çıktısı ({ value, added, removed })
 */
export function diffSection(olderHtml, newerHtml)
{
    const older = htmlToText(olderHtml);
    const newer = htmlToText(newerHtml);

    if (older === newer)
        return { status: (olderHtml || '') === (newerHtml || '') ? 'same' : 'format', text: newer, parts: [] };

    return { status: 'changed', text: newer, parts: diffWords(older, newer) };
}
